import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Loginreq } from '../req/loginreq.model';

@Injectable({
  providedIn: 'root'
})
export class LoginserviceService {

  Url: string = "https://atikaxgfk6.execute-api.ap-south-1.amazonaws.com/dev/superadmin/login";
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };
  http: any;
  constructor(private httpClient : HttpClient) { }
  Userlogin(lgreq: Loginreq) {
    return this.httpClient.post(this.Url, lgreq, this.httpOptions);
  }
  
 
}
